import {
  IconBell, IconBrandTelegram, IconBrandWhatsapp, IconDeviceMobileMessage, IconMail, IconMessage2, IconWebhook, type Icon,
} from "@tabler/icons-react";
import type { Canal } from "../../services/notificaciones-service";

export const ICONO_CANAL: Record<Canal, Icon> = {
  Email: IconMail,
  Campana: IconBell,
  WebPush: IconDeviceMobileMessage,
  Sms: IconMessage2,
  WhatsApp: IconBrandWhatsapp,
  Telegram: IconBrandTelegram,
  Webhook: IconWebhook,
};
